import { ProductTag } from "features/ProductReel/types";
import React from "react";
import styled from "styled-components/macro";
import Label from "./Label";

interface LabelsProps {
  labels?: ProductTag[];
  muted?: boolean;
}

const Labels: React.FC<LabelsProps> = ({ labels, muted = false }) => {
  return (
    <>
      {labels?.map((label, idx) => {
        return (
          <Label
            key={idx}
            text={label.title}
            color={label.color}
            textColor={label.textColor}
            labelType={label.type}
            muted={muted}
          />
        );
      })}
    </>
  );
};

export default Labels;
